export const SLOVENE_TRANSLATIONS = {
    text: {


        //COMPONENTS

        aspectEntry: {
            name: "Name",
            displayLabel: "Display label",
            description: "Description"
        },

        auditLogTable: {

            report: "Poročilo o revizijski sledi",
            time: "čas zapisa",
            user: "uporabnik",
            role: "alfresco vloga",
            event: "dogodek",
            details: "podrobnosti",
            detailsLink: "Podrobno",
            type: "tip",
            itemLabel: "oznaka enote gradiva",
            classLabel: "oznaka razreda",

            auditLogExport: {
                exportJson: "Izvoz v JSON obliki",
                exportXML: "Izvoz v XML obliki",

            },

            auditDetailsModal: {
                title: "Podrobnosti",
                noDetailsAvailable: "Podrobnosti niso na voljo!",

            },



        },

        classificationPlanFilter: {
            //HTML
            selectButtons: {
                selectAll: "Označi vse",
                deselectAll: "Odznači vse"
            },
            filterClearButtons: {

                filters: "Filtri",

            },

            //MODALS
            filterSelectModal: {

                selectFilter: "Določite filter",

                selectLowerBound: "Izberite spodnjo mejo",
                selectCreationDate: "Izberite datum kreiranja",
                selectUsageEndDate: "Izberite datum konca uporabe",
            },


            noClassificationPlanToShow: "Ni klasifikacijskega načrta za prikaz!",
            noClassMatchingSelectedFilters: "Z izbranimi filtri se ne ujema noben razred!",


        },

        detailedSearchFieldAndValue: {

            field: "Polje",
            value: "Vrednost",
            enterValue: "Vnesi vrednost",
            selectDate: "Izberite datum:",
        },

        documentDetailsMetadata: {

            cannotGetMetadata: " Podatka ni mogoče pridobiti.",
            documentForLongTermStorage: "Gradivo v obliki za dolgoročno hrambo",
            documentForLongTermStorageManualAdd: "Ročno dodajanje gradiva v obliki za dolgoročno hrambo",
            documentAuditLog: "Revizijska sled dokumenta",
            documentAuditLogReport: "Poročilo o revizijski sledi za izbrano enoto gradiva",
        },


        footer: {

            vsrs: "© VSRS ",
            version: "Verzija",
        },

        generateReportButton: {

            setCourtModal:  {

                title: "Parametri za pripravo poročila",

                prompt1: "Ustvariti želite poročilo",
                prompt2: "za izbrano",

                date: "Datum",
                dateFrom: "Datum od",
                dateTo: "Datum do",
                user: "Uporabnik",
                stevilkaZadeve: "Opravilna številka zadeve",
                classificationClass: "Klasifikacijski razred",

                reportDescription: "Opis poročila",

                sendRequestForReportCreation: "Oddaj zahtevo za izdelavo poročila",
            },


            dateFromAndDateToAreRequiredFieldsToast: {
                message: "\"Datum od\" in \"Datum do\" sta obvezni polji!",
            },
            selectedRegisterOptionIsRequiredFieldToast: {
                message: "Polje \"Šifrant\" ne sme biti prazno!",
            },
            selectedUserIsRequiredFieldToast: {
                message: "Polje \"Uporabnik\" ne sme biti prazno!",
            },
            selectedStevilkaZadevaIsRequiredFieldToast: {
                message: "Polje \"Opravilna številka zadeve\" ne sme biti prazno!",
            },
            selectedClassificationClassIsRequiredFieldToast: {
                message: "Polje \"Klasifikacijski razred\" ne sme biti prazno!",
            },
            dateIsRequiredFieldToast: {
                message: "Datum je obvezno polje!",
            },

            courtNotSelectedSwal: {
                message1: "Sodišče ni izbrano",
                message2: "Za oddajo zahtevka za poročilo je v filtrih iskanja (stolpec na levi strani rezultatov) obvezno izbrati sodišče.",
            },

            documentNotSelectedSwal: {
                message1: "Gradivo ni izbrano",
                message2: "Za oddajo zahtevka za poročilo je obvezno izbrati gradivo.",
            },

            tooManyDocuments: {
                message1: "Preveč izbranih dokumentov",
                message2: "V eno poročilo je lahko vključenih največ 5000 dokumentov.",
            },


            reportContainsSearchResultsWarning: "Opozorilo: v poročilu bodo zajete vse enote gradiva, ki so rezultat iskanja, ne le posamične izbrane.",
            reportContainsSelectionWarning: "Poročilo vsebuje v rezultatu iskanja izbrane enote gradiva!",
            reportGradivoRokiHrambeWarning: "Opozorilo: Poročilo vsebuje podatke o vsem najdenem gradivu rešenih zadev (ne upošteva posamičnih izbranih enot gradiva), ki mu je rok hrambe pričel teči!",
        },

        header: {

            judiciaryOfSlovenia: "Sodstvo Republike Slovenije",
            name: "Archeía",
            environment: "okolje",
            loggedInAs: "Prijavljeni ste kot",
            logout: "Odjavi se",


            navbar: {
                home: "Domov",
                classificationPlan: "klasifikacijski načrt",
                documents: "Gradivo",
                searchAndOverviews: "Iskanje in pregledi",
                documentSearchFullText: "Iskanje po besedilu",
                documentSearchDetailed: "Osnovno iskanje po metapodatkih",
                documentSearchQuery: "Napredno iskanje po metapodatkih",
                documentSearchTectonical: "Iskanje po vsebini klasifikacijskega načrta",
                unclassifiedFilesReview: "Pregled neklasificiranega gradiva",

                documentListPretecenRokHrambe: "Gradivo s pretečenim rokom hrambe",
                expiredDocuments: "Gradivo za izločitev",
                documentsAssignedIntoReview: "Gradivo, dodeljeno v pregled",
                documentsProposedForDestruction: "Gradivo, predlagano za uničenje",
                documentsReviewedAndConfirmedForDestruction: "Gradivo, potrjeno za uničenje",
                documentsForSubmissionToArchive: "Gradivo, primerno za izročitev državnemu arhivu",
                documentsReviewedByArchive: "Gradivo, izbrano za izročitev državnemu arhivu",
                conversionForLongTermStorage: "Pretvorba v format za dolgoročno hrambo",
                candidatesForDelivery: "Gradivo, potrjeno za izročitev državnemu arhivu",
                deliveredDocuments: "Izročeno gradivo",
                deliveryStatusManualEntry: "Ročni vnos statusa prevzema",
                documentUploadTestClient: "Nalaganje gradiva (testni klient)",

                reports: "Poročila",
                system: "Sistem",
                auditLog: "Revizijska sled",
                auditLogSearch: "Iskanje po revizijski sledi",
                externalAuditLogImport: "Uvoz zunanje revizijske sledi",
                systemPerformance: "Delovanje sistema",
                systemStatus: "Stanje sistema",
                modelsAndMetadataSettings: "Nastavitve modelov in metapodatkov",
                miscellaneousSettings: "Razne nastavitve",

            },


            noInfoOrNoPermissions:  "Ni podatkov o pravicah oz. ni dodeljenih pravic.",

            allCourts: "vsa sodišča",
        },

        modelEntry: {

            namespace: "Namespace",
            displayLabel: "Display label",
            name: "Name",
            description: "Description",


        },

        propertyEntry: {

            displayLabel: "Display label",
            name: "Name",
            description: "Description",
            dataType: "Data type",
            requirement: "Requirement",
            defaultValue: "Default value",
            constraint: "Constraint",
            regularExpression: "Regular expression",
            minimumLength: "Minimum length",
            maximumLength: "Maximum length",
            minimumValue: "Minimum value",
            maximumValue: "Maximum value",
            javaClassName: "Java class name",
            javaClass: "Java Class",
            indexed: "Indexed",
            minMaxLength: "Minimum / maximum length",
            minMaxValue: "Minimum / maximum value",

            dataTypeOptions: ['d:text','d:mltext','d:int', 'd:long', 'd:float', 'd:double', 'd:date', 'd:datetime', 'd:boolean'],
            requirementOptions: ['Mandatory', 'Optional'],
            constraintOptions: ['None','Regular expression','Minimum / maximum length', 'Minimum / maximum value', 'List of Values', 'Java Class'],

            indexedOptionsText: ['Free Text','List of Values - Whole Match','List of Values - Partial Match', 'Pattern - Unique Matches', 'Pattern - Many Matches'],
            indexedOptionsBoolean: ["None", "Basic"],
            indexedOptionsDefault: ["Basic", "Enhanced"],

            dataTypeDefault: "d:text",
            requirementDefault: "Optional",
            constraintDefault: "None",
            indexedDefault: "Free Text",
            basic: "Basic",


        },

        searchResults: {
            filters: "Filtri",
            clearFilters: "Počisti filtre",
            size: "Velikost",
            classificationLabel: "Klasifikacijska oznaka razreda",
            documentStatus: "Status gradiva",
            connectedSystemLabel: "Oznaka povezanega sistema",
            registryLabel: "Oznaka vpisnika",

            physicalFormDocument: "Gradivo v fizični obliki",

            searchResults1: "Rezultati iskanja",
            searchResults2: "zadetkov",

            searchResultsWithSelection: {
                numOfSelectedDocuments: "Št. izbranih dokumentov",
                numOfResultsPerPage: "Št. zadetkov na stran",
                expirationsExport: "Izvoz rokov hrambe",
                selectAllDocumentsOnCurrentPage: "Izberi vse dokumente na trenutni strani",

                documentsNotSelectedExportSwal: {
                    title: "Gradivo ni izbrano",
                    prompt: "Za izvoz rokov hrambe je izbira gradiva obvezna.",
                },

            }

        },

        signatureValidation: {

            checkSignatureValidity1: "Preveri veljavnost",
            checkSignatureValidity2: "podpisa",
            checkSignatureValidity3: "podpisov",

            signatureInformation: "Podatki o podpisu dokumenta",

            result: "rezultat",
            signature: "podpis",

            eIDASValidation: "Validacija po eIDAS (ETSI 119 172-4)",
            modalTitle: "Podatki o podpisu dokumenta",
            signatureInfoFromMetadata: "Podatki o podpisih iz metapodatkov",

            certificateNotSigned: "Gradivo ni elektronsko podpisano",
            certificateSignatureValidityCheckInProgress: "Preverjanje veljavnosti podpisa v teku",

            signatureType: "Tip podpisa",
            validityWitheIDAS: "Skladnost z eIDAS",
            signatureValidity: "Veljavnost podpisa",
            signeeNameAndSurname: "Ime in priimek podpisnika",
            signatureTime: "Datum in ura podpisa",
            timestampInfo: "Informacija o časovnem žigu",
            certificateIssuer: "Izdajatelj certifikata",
            certificateSerial: "Številka certifikata",
            validFrom: "Velja od",
            validTo: "Velja do",
            validationCheckTime: "Čas preverjanja elektronskega podpisa",

            getReadableResult: {
                valid: "Veljaven",
                invalid: "Neveljaven",
                unknown: "Rezultat ni znan",
            },
            getReadableBoolean: {
                unknown: "vrednost ni znana",
            },

        },

        treeItem: {
            //POPOVER
            contentDescription: "Opis vsebine",
            creationDate: "Ustvarjeno",

            classificationPlanContainsDocumentsWarning: "Klasifikacijski razred vsebuje gradivo.",
            //SWAL

            closedClassMoveErrorSwal: {
                content: "Premeščanje zaprtega razreda ni dovoljeno.",
            }
        },

        treeItemForPrint: {
            expirationNotSet: "Rok hrambe ni določen",

        },

        treeStructureForPrint: {
            usageEndDate: "Datum konca uporabe",
        },


        // PAGES

        adminTools: {

            modelEditor: "Urejevalnik modelov",
            models: "Modeli",
            apm: "APM",
            services: "Services",

        },

        apmPages: {

            transactionsLabel: "Transactions",
            errors: "Errors",
            metrics: "Metrics",
            chooseDate: "Izberite datum: ",
            apmLabel: "APM",
            services: "Services",
            errorOccurrences: "Error occurrences",
            unavailable:  "unavailable",


            average: "Average",
            ninetyNinthPercentile: "99th percentile",
            ninetyFifthPercentile: "95th percentile",

            systemMax: "System max",
            systemAverage: "System average",
            processMax: "Process max",
            processAverage: "Process average",

            ms: "ms",
            tpm: "tpm",
            rpm: "rpm",
            epm: "epm",


            requestsPerMinute: "Requests per minute",
            transactionDuration: "Transaction duration",

            tableColumns: {
                serviceName: "Name",
                agentName: "Agent",
                avgResponseTime: "Average response time",
                avgDuration: "Average duration",
                transactionsPerMinute: "Transactions per minute",
                errorsPerMinute: "Errors per minute",

                groupId: "Group ID",
                message: "Error message and culprit",
                occurrenceCount: "Occurrences",
                latestOccurrenceAt: "Latest occurrence",

                p95: "95th percentile",
                impact: "Impact",

                finalUser: "Archeía user",
                ip: "IP",


            },

            apmErrorGroup: {

                errorGroup: "Error group",
                exceptionMessage: "Exception message",
                culprit: "Culprit",
                errorOccurrence: "Error occurrence",
                timestamp: "Timestamp",
                url: "URL",
                requestMethod: "Request method",
                handled: "Handled",
                transactionSampleId: "Transaction sample ID",
                userId: "User ID",
                noData: "No data available",
                libraryFrames: "Library frames",

                exceptionStacktrace: "Exception stacktrace",
                host: "Host",
                service: "Service",
                process: "Process",
                agent: "Agent",
                container: "Container",
                user: "User",
                labels: "Labels",

                in: "in",
                at: "at",
                line: "line",

            },

            apmErrors: {},

            apmMetrics: {

                cpuUsage: "CPU usage",
                memoryUsage: "Memory usage",

            },

            transactionGroup: {
                noDataForSelectedTimeFrame: "Podatki za izbran časovni niz niso na voljo.",
            },
            transactions: {
                transactionGroups: "Transaction groups",
            },

        },

        aspects: {

            aspects: "Aspekti",
            createAspect: "Ustvari aspekt",

            createAspectModal: {

                title: "Create aspect",
            },

            editAspectModal: {

                title: "Edit aspect",
            },

            deleteAspectModal: {

                title: "Delete aspect",
                prompt: "Do you really want to delete this aspect?",
            },

            models: "Models",
            aspectsLabel: "Aspects",


            prefixedName: "Name",
            title: "Display Label",
            action: "Actions",

            edit: "Edit",
            delete: "Delete",

        },

        auditLog: {
            auditLogSearch: "Iskanje po revizijski sledi",

            internalAuditLog: {
                linkToExternalAuditLog: "Zunanja revizijska sled",
                entryLimitSelect: "Maksimalno št. zapisov na revizijski razdelek",
                type: "Tip",
                event: "Dogodek",
                eHrambaUser: "Končni uporabnik",
                noResultsWithFilters: "Ni zadetkov, ki bi ustrezali iskalnim filtrom.",
                latestTransferTime: "Arhiv vsebuje zapise do",

                combinedView: "Združen pregled",
                eHrambaLog: "Archeía Log",
                recordsManagement: "Records Management",
                cmisLog: "CMIS Log",
                ehrambaLogOld: "eHramba Log",
                lotsOfData: "Poizvedba po revizijski sledi bo zaradi velike količine obdelanih podatkov trajala dalj časa. V kolikor želite, da se poizvedba izvrši do konca in njen rezultat prenese v poročilo, izbiro potrdite s pritiskom na gumb Izvedi poizvedbo in rezultat shrani v poročilo. Rezultat poizvedbe ne bo prikazan na ekranu.",
                lotsOfDataReport: "Izvedi poizvedbo in rezultat shrani v poročilo",

            },
            externalAuditLog: {
                title: "Zunanja revizijska sled",
                externalSystemId: "ID oznaka zunanjega sistema",
                linkToInternalAuditLog: "Notranja revizijska sled",
            },
            registerAuditLog: {
                title: "Revizijska sled šifrantov",
                register: "Šifrant",
            },

            dateFrom: "Datum (od)",
            dateTo: "Datum (do)",
            user: "Uporabnik",

            enterValue: "vnesi vrednost",
            filterDataMissing: "Manjkajoči podatki za iskanje",
            datesRequired: "Polji \'Datum od\' in \'Datum do\' sta obvezni za izvedbo iskanja."
        },

        auditLogExternalImport: {
            title: "Uvoz zunanje revizijske sledi",
            downloadSample: {
                label: "Prenos vzorca",
                downloadJson: "Vzorec v JSON obliki",
                downloadXML: "Vzorec v XML obliki",
            },
            fileToImport: "Datoteka za uvoz",
            importButton: "Uvozi",
            linkToExternalAuditLogSearch: "Iskanje po zunanji revizijski sledi",
            auditLogExternalImportSuccessToast: "Uvoz zunanje revizijske sledi uspešno izveden.",


        },

        cacheInstanceEntry: {
            addCacheInstance: "Dodaj instanco predpomnilnika",
            editCacheInstance: "Uredi instanco predpomnilnika",

            name: "Naziv",
            uuidLabel:"UUID oznaka",
            createUuidlabel: "Ustvari UUID oznako",
            sharedKey: "Skupni ključ",
            password: "Geslo",
            latitude: "Zemljepisna širina (LAT)",
            longitude: "Zemljepisna dolžina (LONG)",

            instanceStatus: "Stanje aktivnosti",
            instanceIsActive: "Instanca je aktivna",
            instanceIsInactive: " Instanca je neaktivna",
            addInstance: "Dodaj instanco",

            deleteInstanceConfirmationSwal: {
                content: "Ali ste prepričani, da želite izbrisati predpomnilink ",


            },

        },

        cacheTestClient: {
            cacheTestClient: "Testni klient za predpomnilnike",

            openBrowserWithCustomSettingsPrompt: "Ker predpomnilniki tečejo na drugih naslovih kot aplikacija Archeía, spletni brskalniki privzeto ne dovoljujejo izvajanja REST klicev. Zato je za uporabo testnega klienta za predpomnilnike brskalnik potrebno odpreti z nastavitvami, ki omogočajo izvajanje takšnih klicev.",


            disableSecurityChromeWindowsTitle: "Brskalnik Chrome na Windows",
            disableSecurityChromeWindowsCommand: "\"C:\\Program Files (x86)\\Google\\Chrome\\Application\\chrome.exe\" --user-data-dir=~/chromeTemp --disable-web-security --allow-running-insecure-content",


            disableSecurityChromeMacOsTitle: "Brskalnik Chrome na MacOS",
            disableSecurityChromeMacOsCommand: "open -n -a /Applications/Google\\ Chrome.app/Contents/MacOS/Google\\ Chrome --args --user-data-dir=\"/tmp/chrome_dev_sess_1\" --disable-web-security --allow-running-insecure-content",

            disableSecurityChromeLinuxTitle: "Brskalnik Chrome na Linux",
            disableSecurityChromeLinuxCommand: "google-chrome --disable-web-security --allow-running-insecure-content",


            cacheUrl: "URL naslov predpomnilnika",
            documentUuid: "UIID gradiva",
            getDocumentMetadata: "Pridobi podatke o gradivu",

            documentDetailsViaAlfresco: "Podrobnosti gradiva preko Alfresco sistema",
            documentDetailsViaCache: "Podrobnosti gradiva preko predpomnilnika",


        },

        classificationPlan: {
            //HTML
            connectToAlfrescoErrorWarning: "Povezave z Alfresco sistemom ni bilo mogoče vzpostaviti, zato ni mogoče pridobiti najnovejših podatkov in shranjevati sprememb. Za pomoč se obrnite na administratorja.",
            title: "Klasifikacijski načrt",
            import: "Uvoz",
            sampleExport: "Prenos vzorca",
            move: "Premestitev",
            viewAndSearch: "Iskanje in pregled",
            print: "Tiskanje",
            reports: "Priprava poročil",
            exportStorageDates: "Izvoz rokov hrambe",
            expandAll: "Razširi vse",
            minimizeAll: "Skrči vse",
            localChangesMessage: " V klasifikacijskem načrtu so bile izvedene lokalne spremembe, ki še niso shranjene na strežniku!",
            chooseClass: "S klikom izberite razred!",
            addClass: "Dodajanje razreda",
            editClass: "Urejanje",
            deleteClass: "Brisanje",
            classificationPlanContainsErrors: " Klasifikacijski načrt, ki ga poskušate oddati, vsebuje napake.",
            rootClass: "Korenski načrt",


            tooltips: {
                classificationPlanImport: "Uvoz klasifikacijskega načrta",
                additionalClassificationPlanImport: "Naknadni uvoz klasifikacijskega načrta",
                classificationPlanExport: "Izvoz klasifikacijskega načrta",
                sampleClassificationPlanExport: "Prenos vzorčnega klasifikacijskega načrta",
                moveClass: {
                    title: "Premestitev razredov",
                    dragAndDropMove: "Premik z metodo \"povleci in spusti\"",
                    parentClassChooseMove: "Premik z izbiro nadrejenega razreda",
                },

                reviewClass: "Pregled razredov",

                toggleClassCollapse: "Razširi/skrči vse (pod)razred",

                addChildClass: "Dodajanje razreda",
                editClass: "Urejanje razreda",
                deleteClass: "Brisanje razreda",

            },


            //MODALS
            importPreviewModalTitle: "Predogled uvoza klasifikacijskega načrta",
            importErrorModalTitle: "Napaka pri uvažanju klasifikacijskega načrta",
            importErrorDuplicatedClassLabelPart1: "Razreda s klasifikacijsko oznako",
            importErrorDuplicatedClassLabelPart2: "in nazivom",
            importErrorDuplicatedClassLabelPart3: "ni bilo mogoče uvoziti, saj v klasifikacijskem načrtu razred s takšno oznako že obstaja.",
            moveErrorModal: {
                title: "Napaka pri premiku razreda",
                error: "Premik razreda ni veljaven!",
            },
            moveReasonModal: {
                title: "Navedite razlog za premestitev razreda",
                reason: "Razlog",
                reasonNotGiven: "Razlog ni podan!",
                newClassificationLabel: "Nova klasifikacijska oznaka",
                newClassificationLabelNotGiven: "Nova klasifikacijska oznaka ni določena.",
                newClassificationLabelSyntaxError1: "Zapis klasifikacijske oznake ni ustrezen. Prvi del oznake mora vsebovati klasifikacijsko oznako nadrejenega razreda (",
                newClassificationLabelSyntaxError2: "), tej pa mora slediti še vsaj ena dodatna številka.",

                showPreview: "Prikaži predogled",
                hidePreview: "Skrij predogled",

            },
            additionalAppendModal: {
                title: "Ali želite izbrati nadrejeni razred naknadno uvoženega razreda?",
                info:  "Če izberete nadrejeni razred, bodo vsi razredi, ki v vhodni XML datoteki nimajo opredeljenih nadrejenih razredov, umeščeni v izbrani nadrejeni razred. Razredi, ki imajo opredeljene nadrejene razrede, bodo razporejeni skladno z opredelitvijo strukture v XML datoteki.",
            },
            exportModalTitle: "Izvoz klasifikacijskega načrta",
            moveModal: {
                title: "Premestitev razredov",
                noClassificationPlan: "Ni klasifikacijskega načrta za prikaz!",
            },
            printModalTitle: "Tiskanje klasifikacijskega načrta",
            duplicateClassesMessage: "Podvojeni razredi v klasifikacijskem načrtu.",

            selectParentClassModal: {
                title: "Premik razreda",
                selectNewParentClass: "Izberite nov nadrejen razred, kamor želite premakniti razred",

            },


            //SWALS


            movingClassContainsRecordsSwal: {
                content: "Razred, ki ga želite premestiti, vsebuje gradivo. Skupaj z razredom bo premeščeno tudi gradivo. Ali ste prepričani, da želite premestiti razred?",
            },
            closeLocallyChangedClassificationPlanSwal: {
                content: "Poskušate zapustiti urejanje klasifikacijskega načrta, čeprav so bile v načrtu izvedene lokalne spremembe, ki še niso shranjene na strežniku.\n\nČe se odločite zapustiti to stran, bodo spremembe izgubljene.",
                leavePage: "Zapusti stran",
            },
            locallyChangedClassificationPlanSaveErrorSwal: {
                title: "Pri shranjevanju klasifikacijskega načrta je prišlo do napake:",
                content: "Med vašim lokalnim urejanjem je bil klasifikacijski načrt spremenjen na strežniku, zato sprememb ni bilo mogoče shraniti. Kliknite na gumb Opusti spremembe, nato pa vaše spremembe ponovno dodajte.",
            },
            cancelLocalClassificationPlanChangesSwal: {
                title: "Ste prepričani, da želite preklicati spremembe?",
                content: "Če prekličete spremembe, ki ste jih lokalno naredili na klasifikacijksem načrtu, se boste vrnili na zadnjo shranjeno verzijo klasifikacijskega načrta.",
            },

            printExportEmptyClassificationPlanErrorSwal: {
                content: "Klasifikacijski načrt je prazen.",
            },

            tooManyClassificationClassesSelected: {
                content: "Izbranih je preveč klasifikacijskih razredov. Za oddajo poročila izberite do največ 100 razredov.",
            },

            deleteClassificationPlanEntrySwal: {
                content: "Ali ste prepričani, da želite izbrisati klasifikacijski razred (",
            },

            deleteClassificationPlanEntryContainingDocumentsErrorSwal: {
                content: "Brisanje klasifikacijskih razredov, ki imajo klasificirane dokumente, ni mogoče!",
            },
            deleteClassificationPlanEntryContainingChildrenErrorSwal: {
                content: "Brisanje klasifikacijskih razredov, ki vsebujejo podrejene razrede, ni mogoče!",
            },

            editClassificationPlanEntryContainingRecordsErrorSwal: {
                content: "Urejanje klasifikacijskih razredov, ki vsebujejo gradivo, ni mogoče!"
            },

            moveClassificationPlanEntryContainingDocumentsErrorSwal: {
                content: "Razred, ki ga želite premestiti, vsebuje gradivo. Skupaj z razredom bo premeščeno tudi gradivo. Ali ste prepričani, da želite premestiti razred?",
            },

            movingClassContainsRecordsNoAdminErrorSwal: {
                content: "Za premikanje razredov z gradivom uporabite namensko funkcionalnost (gumb nad klasifikacijskim načrtom)."
            },

            noClassSelectedSwal: {
                title: "Noben razred ni izbran",
                prompt: "Za premik z določitvijo nadrejenega razredma, je obvezno izbrati razred, ki ga želite premakniti.",
            },

            newParentClassNotSelectedSwal: {
                title: "Nov nadrejeni razred ni izbran",
                prompt: "Za premik je obvezno izbrati nadrejeni razred, kamor želite izbran razreda premakniti.",
            },

            //TOASTS
            classificationPlanSuccessfullySavedToast: "Klasifikacijski načrt uspešno shranjen!",
            classificationPlanSaveErrorToast: "Pri shranjevanju klasifikacijskega načrta je prišlo do napake.",

            //UPLOAD ERRORS
            XMLStructureError: "Napaka v xml strukturi datoteke.",
            missingClassificationLabelsInXML: "V xml stukturi obstajajo razredi, ki jim manjka klasifikacijska oznaka.",
            documentStructureError: "Napaka v strukturi dokumenta.",
            fileTypeError: "Naložili ste neustrezen tip datoteke. Zahtevana je datoteka tipa XML.",
            duplicateClassesError: "Klasifikacijski načrt vsebuje podvojene razrede.",
            duplicatedClasses: "Oznake podvojenih razredov:",

            searchableFieldsPrint: [
                {
                    id: 'label',
                    description: 'Klasifikacijska oznaka',
                },
                {
                    id: 'labelName',
                    description: 'Naziv klasifikacijske oznake',
                },
                {
                    id: 'povezaniSistemi',
                    description: 'Povezan sistem',
                },
                {
                    id: 'rokHrambe',
                    description: 'Rok hrambe',
                },
                {
                    id: 'vrstaGradiva',
                    description: 'Vrsta gradiva',
                },
                {
                    id: 'vpisnik',
                    description: 'Vpisnik',
                },
                {
                    id: 'creationDate',
                    description: 'Datum nastanka',
                },
                {
                    id: 'usageEndDate',
                    description: 'Datum konca uporabe',
                }

            ]

        },

        classificationPlanEntry: {

            //HTML
            addClassificationPlanEntry: "Dodaj vnos v klasifikacijski načrt",
            editClassificationPlanEntry: "Uredi vnos v klasifikacijskem načrtu",

            hideClassificationPlan: "Skrij klasifikacijski načrt",
            showClassificationPlan: "Prikaži klasifikacijski načrt",

            parentClass: "Nadrejeni razred",

            rootPlan: "Korenski načrt",

            classificationLabel: {
                title: "Klasifikacijska oznaka",
                missingError: "Polje Klasifikacijska oznaka je obvezno.",
                valueError1: "Zapis klasifikacijske oznake ni ustrezen. Prvi del oznake mora vsebovati klasifikacijsko oznako nadrejenega razreda (",
                valueError2: "), tej pa mora slediti še vsaj ena dodatna številka. Klasifikacijska oznaka je lahko sestavljena samo iz števk.",
            },
            classificationLabelName: {
                title: "Naziv klasifikacijske oznake",
                error: "Polje Naziv klasifikacijske oznake je obvezno.",
                duplicateError: "Znotraj istega nadrejenega razreda ni dovoljeno imeti več razredov z enakim nazivom.",
                illegalCharactersError: "Neveljaven znak v imenu razreda. Veljavni znaki so: črke, številke, presledek, pika, vejica, oklepaj, zaklepaj, dvopičje, podčrtaj, pomišljaj in poševnica.",
            },
            classificationLabelDescription: {
                title: "Opis klasifikacijske oznake",
                error: "Polje Opis klasifikacijske oznake je obvezno.",
            },
            expiration: {
                year: "Leta",
                expirationType: "Vrsta hrambe",
                noExpirationsAdded: "Trenutno ni dodanih rokov hrambe.",
                generalExpirationError: "Dodan mora biti en Osnovni rok hrambe.",
                addExpiration: "Dodaj rok hrambe",
            },
            connectedSystems: {
                noConnectedSystemsAdded: "Ni dodanih povezanih sistemov.",
                addConnectedSystem: "Dodaj povezan sistem",
            },
            registry: {
                noRegistriesAdded: "Trenutno ni dodanih vpisnikov.",
                addRegistry: "Dodaj vpisnik",
            },
            creationDate: {
                title: "Datum kreiranja",
            },

            closeClass: "Zaprtje razreda",
            closeClassCancel: "Prekliči zaprtje razreda",

            usageEndDate: {
                title: "Datum konca uporabe",
                error: "Manjka zaprtje razreda. Dodajte datum zaprtja razreda ali pa kliknite na gumb 'Prekliči zaprtje razreda'.",
                errorValue: "Datum zaprtja razreda mora biti novejši od datuma odprtja razreda."
            },

            addClass:"Dodaj razred",
            saveClass: "Shrani razred",

            //MODALS

            duplicatesErrorModal: {
                content: "Podvojeni razredi v klasifikacijskem načrtu.",
            },

            usageEndDateErrorModal: {
                content: " Manjka zaprtje razreda. Dodajte datum zaprtja razreda ali pa kliknite na gumb 'Prekliči zaprtje razreda'.",
            },

            noExpirationTypeErrorModal: {
                content: "Vrsta gradiva ni določena.",
            },

            generalExpirationErrorModal: {
                content: "Osnovni rok hrambe v tem razredu že obstaja, zato osnovnih rokov hrambe ni več mogoče dodajati. Poskusite z urejanjem ali brisanjem že obstoječega osnovnega roka hrambe.",
            },

            tooLongLabelNameErrorModal: {
                content: "Predolg naziv klasifikacijske oznake, uporabite največ 150 znakov.",
            },

            generalExpirationExistsErrorModal: {
                content: "Osnovni rok hrambe že obstaja.",
            },

            expirationModal: {
                expirationError: "Polje Rok hrambe je obvezno.",

                restrictedToMissingError: "Polje Omejeno na je obvezno.",
                restrictedToNumericError: "Polje Omejeno na mora biti pozitivno celo število.",

                generalExpiration: "Osnovni rok hrambe",

                expirationType: "Vrsta gradiva",
                expirationTypeError: "Polje vrsta gradiva je obvezno.",
                duplicateExpirationError1: "Rok hrambe z vrsto gradiva ",
                duplicateExpirationError2: " že obstaja.",

                years: "let",

                addExpiration: {
                    title: "Dodajanje roka hrambe",
                    addExpiration: "Dodaj rok hrambe",
                },
                editExpiration: {
                    title: "Urejanje roka hrambe",
                    saveExpiration: "Shrani rok hrambe",
                },
                deleteExpiration: {
                    title: "Brisanje roka hrambe",
                    content: "Ste prepričani, da želite izbrisati rok hrambe",

                }
            },

            connectedSystemsModal: {

                connectedSystemsError: "Polje povezani sistemi je obvezno.",
                duplicateConnectedSystemsError1: "Povezan sistem ",
                duplicateConnectedSystemsError2: " že obstaja.",

                addConnectedSystem: {
                    title: "Dodajanje povezanih sistemov",
                    addConnectedSystem: "Dodaj povezan sistem",
                },
                editConnectedSystem: {
                    title: "Urejanje povezanih sistemov",
                    saveConnectedSystem: "Shrani povezan sistem",
                }
            },

            registryModal: {
                registryError: "Polje vpisnik je obvezno.",
                selectAll: "Izberi vse",


                duplicateRegistryError1: "Vpisnik",
                duplicateRegistryError2_1: " ",
                duplicateRegistryError2_2: "i ",
                duplicateRegistryError3: "že obstaja",
                duplicateRegistryError4_1: ".",
                duplicateRegistryError4_2: "jo.",

                duplicateRegistryErrorEdit1: "Vpisnik ",
                duplicateRegistryErrorEdit2: " je že dodan.",

                addRegistry: {
                    title: "Dodajanje vpisnika",
                    addRegistry: "Dodaj vpisnik",
                },
                editRegistry: {
                    title: "Urejanje vpisnika",
                    saveRegistry: "Shrani vpisnik",
                },
            },

            //SWALS

            connectedSystemShouldNotEditSwal: {
                content1: "Povezanega sistema ",
                content2: " ni mogoče urejati, saj so v klasifikacijski načrt dodani vpisniki, ki se navezujejo na ta povezani sistem.",
            },

            connectedSystemShouldNotDeleteSwal: {
                content1: "Povezanega sistema ",
                content2: " ni mogoče odstraniti, saj so v klasifikacijski načrt dodani vpisniki, ki se navezujejo na ta povezani sistem.",
            },

            deleteConnectedSystemSwal: {
                content: "Ali ste prepričani, da želite izbrisati povezan sistem ",
            },

            noConnectedSystemsAddedSwal: {
                content: "Za dodajanje vpisnikov je potrebno najprej dodati vsaj en povezan sistem!",
            },

            deleteRegistrySwal: {
                content: "Ali ste prepričani, da želite izbrisati vpisnik ",
            },

            deleteConnectedSystemsInClassWithRecordsSwal: {
                content: "Brisanje vpisnikov na klasifikacijskem razredu, ki že vsebuje gradivo, lahko traja dlje časa, saj je za to spremembo potrebno preveriti, da teh podatkov ne vsebuje nobeno gradivo v tem klasifikacijskem razredu."
            },

            //TOASTS

            metadataValidationErrorToast: "Pri validaciji podatkov so bile zaznane napake.",

        },

        classificationPlanPrint: {
            leavePageWarning: "Leaving this page will block the parent window!\\nPlease select \"Stay on this Page option\" and use the\\nCancel button instead to close the Print Preview Window.\\n",
        },

        classificationPlanReview: {
            title: "Pregled klasifikacijskega načrta",
            classificationPlanExportModal: {
                title: "Izvoz klasifikacijskega načrta",
            },
            classificationPlanPrintModal: {
                title: "Tiskanje klasifikacijskega načrta",
            },
            exportButton: {
                tooltip: "Izvoz klasifikacijskega načrta",
            },
            printButton:{
                label: "Tiskanje",
                tooltip: "Tiskanje",
            },
        },

        dashboard: {
            logoutInProgress: "Odjava v teku",

            welcomeMessage1: "👋 Dobrodošli",
            welcomeMessage2: "v administrativnem modulu sistema Archeía.",

            loggedInAs: "Prijavljeni ste kot",

            contactEmailForHelp: "Kontaktni naslov za pomoč",

        },

        documentAddVersion: {
            newDocumentVersionUpload: "Nalaganje nove različice dokumenta",
            fileToUpload: "Datoteka za nalaganje",

            user: "Uporabnik",

            alfrescoUser: "alfrescoUser",
            alfrescoPassword: "alfrescoPassword",
            externalUserType: "externalUserType",
            externalUserTypeOptions: ['up_varnostne_sheme','up_s_certifikatom'],
            externalUserId: "externalUserId",
            externalUserCertId: "externalUserCertId",

            backToDocument: "Nazaj na dokument",

            documentVersionUploadSuccessToast: "Verzija dokumenta uspešno naložena!",
            mimetypeRequired: "Polje mimetype ne sme biti prazno!"

        },

        //documentCopyToEvipTestClient: {},

            documentDetails: {

            loadingTime: "Čas nalaganja",
            milliseconds: "ms",
            documentArchived: "Gradivo arhivirano",
            documentDeleted: "Gradivo izbrisano",
            documentSearch: "Iskanje dokumentov",

            editTestClient: "Uredi (test klient)",
            evipCaptureTestClient: "Zajem EVIP (test klient)",
            documentMoveTestClient: "Premestitev gradiva (test klient)",
            newVersionUploadTestClient: "Naloži novo različico (test)",
            changeStorageLocation: "Spremeni mesto hrambe",

            expirationState: "Status roka hrambe",

            recordSearchDispositionActionName: "recordSearchDispositionActionName",
            recordSearchDispositionActionAsOf: "recordSearchDispositionActionAsOf",

            endCurrentExpirationStep: "Zaključi trenutni korak roka hrambe",

            informationCannotBeRetrieved: "Podatka ni mogoče pridobiti",


            documentInLongTermStorageForm: "Gradivo v obliki za dolgoročno hrambo",
            documentInLongTermStorageFormManualAdd: "Ročno dodajanje gradiva v obliki za dolgoročno hrambo",

            previewTooLarge: "Dokumenta ni mogoče prikazati v brskalniku. Razlog je lahko prevelika velikost dokumenta ali nepodprt format dokumenta.",
            previewTooLargeDownload: "Za ogled je potrebno dokument prenesti",

            documentAuditLog: "Revizijska sled dokumenta",
            documentAuditLogReport: "Poročilo o revizijski sledi za izbrano enoto gradiva",

            archivedDocumentDeletionModal: {

                title: "Izredno brisanje arhiviranega gradiva",
                prompt1: "Če želite izredno izbrisati arhivirano gradivo ",
                prompt2: ", vpišite komentar in potrdite izbris.",

            },

            archivedDocumentStorageLocationEditModal: {
                title: "Urejanje mesta hrambe arhiviranega gradiva",
                allFieldsRequired: "Vsi podatki so obvezni!",
                sendDate: "Datum pošiljanja gradiva z lokacije",
                receivedDate: "Datum sprejema gradiva na lokacijo",
                newLocation: "Lokacija hrambe",

            },


            documentPreviewNotAvailableToast: {
                message: "Predogled gradiva ni na voljo.",
            },

            requestSuccessfullySentToast: {
                message: "Zahtevek uspešno oddan!",
            },

            deleteDocumentWarningSwal: {
                prompt: "Ali ste prepričani, da želite izbrisati dokument ",
            },

            selectedDocumentContainsComponentsSwal: {
                title: "Izbrano gradivo ima priloge oz. komponente!",
                cancelText: "Prekliči brisanje",
                confirmText: "Vseeno izbriši izbrano gradivo",
            },

            errorWhenGettingComponentInfoToast: {
                message: "Pri pridobivanju informacij o prilogah in komponentah izbranega gradiva je prišlo do napake!",
            },

            storageLocationChangeSuccessfulToast: {
                message: "Gradivu je bilo mesto hrambe uspešno spremenjeno!",
            },

            storageLocationChangeErrorToast: {
                message: "Pri spreminjanju mesta hrambe gradiva je prišlo do napake!",
            },

            recordMarkedForAccessionCouldNotBeDestroyedErrorMsg: "Dokumenta ni mogoče brisati, ker je označen za izročanje!"

        },

        documentDetailsEdit: {

            file: "Datoteka",

            errorMessages: {
                titleFieldRequired: "Polje Naslov je obvezno",
                descriptionFieldRequired: "Polje Opis je obvezno",
                authorFieldRequired: "Polje Avtor je obvezno",

            },

            documentVersionType: "Tip verzije dokumenta (za sprembo oznake verzije)",

            fieldShouldNotBeEmpty: "Polje ne sme biti prazno",
            valueMustBeNumeric: "Vrednost mora biti številka",

            uploadNewDocumentVersion: "Naloži novo verzijo dokumenta",

            downloadFile: "Prenesi datoteko",
            documentPreview: "Predogled gradiva",

            documentSuccessfullySent: "Gradivo uspešno oddano!",

        },

        //documentDetailsEditTestClient: {},

        documentLists: {

            reportRecordsWarning: "V poročilu bodo zajete vse enote gradiva, ki so rezultat iskanja, ne le posamične izbrane.",
            classificationLabel: "Klasifikacijska oznaka razreda",
            lastStatusChangeDate: "Datum zadnje spremembe statusa",
            accession: "Izročitev",
            checkedForAccession: "Pregledan za izročanje",

            selectedDocuments: "Izbrani dokumenti",
            extendExpiration: "Podaljšaj rok hrambe",
            selectForDestruction: "Označi za uničenje",
            confirmForDestruction: "Potrdi za uničenje",
            extendExpirationIntoArchived: "Podaljšaj rok hrambe v arhivsko gradivo",
            destroySelectedDocuments: "Uniči izbrano gradivo",
            prepareDocumentInventoryForDestruction: "Pripravi popis dokumentarnega gradiva za uničenje",
            confirmForAccession: "Potrdi za izročanje",
            rejectForAccession: "Zavrni za izročanje",
            convertToLongTermStorageFormat: "Pretvori v obliko za dolgoročno hrambo",
            performAccessionOnSelectedDocuments: "Izroči izbrano gradivo",
            performAccession: "Izroči gradivo",
            makeDocumentAccessionReport: "Poročilo o izročenem gradivu",

            name: "ime",
            uuid: "uuid",
            caseNumberAbbreviated: "opr. št. zadeve",

            documentsMustBeSelectedWarning: "Za predodeljevanje, podaljšanje roka ali označevanje za uničenje, je potrebno najprej izbrati gradivo!",
            documentsMustBeSelectedForDestructionWarning: "Za izvedbo akcije uničenja gradiva, je potrebno najprej izbrati gradivo!",
            documentsMustBeSelectedForAccessionConfirmationOrRejection: "Za potrditev oz. zavrnitev izročanja gradiva, je potrebno najprej izbrati gradivo!",
            documentsMustBeSelectedForLongTermStorageConversion: "Za pretvorbo v obliko zapisa za dolgoročno hrambo, je potrebno najprej izbrati gradivo!",
            documentsMustBeSelectedForAccession: "Za izročanje gradiva je potrebno najprej izbrati gradivo!",

            deselectAll: "Odznači vse",
            selectAll: "Označi vse",

            openingIsEnabledJustForFilesToast: "Odpiranje je omogočeno samo za datoteke.",

            selectedDocumentsSuccessfullyReassignedToast: "Izbrano gradivo uspešno predodeljeno!",
            selectedDocumentsUnsuccessfullyReassignedToast: "Pri dodeljevanju gradiva je prišlo do napake!",
            selectedDocumentsSuccessfullyReassignedAltToast: "Gradivo uspešno označeno za izročanje!",

            selectedDocumentsSuccessfullyConvertedToast: "Izbrano gradivo uspešno pretvorjeno!",
            selectedDocumentsUnsuccessfullyConvertedToast: "Pri pretvorbi gradiva je prišlo do napake!",

            longTermConversionRequestSuccessfullySubmitted: "Poizkus pretvorbe uspešno sprožen",
            longTermConversionRequestUnsuccessfullySubmitted: "Zahtevek za poizkus pretvorbe neuspešno sprožen",

            expirationChangeSuccessToast: "Izbranemu gradivu uspešno spremenjen rok hrambe!",
            expirationChangeErrorToast: "Pri spreminjanju roka hrambe je prišlo do napake!",
            expirationChangeNotAvailableToast: "Gradivu z nepretečenim rokom hrambe ni mogoče podaljšati roka hrambe, ga uničiti ali ga predodeliti v pregled.",

            documentSuccessfullyAssignedToDestructionListToast: "Izbrano gradivo uspešno uvrščeno na seznam gradiva za uničenje!",
            documentUnsuccessfullyAssignedToDestructionListToast: "Pri uvrščanju na seznam gradiva za uničenje je prišlo do napake!",

            selectedDocumentsSuccessfullyDestroyed: "Izbrano gradivo uspešno uničeno!",
            selectedDocumentsUnsuccessfullyDestroyed: "Pri uničevanju gradiva je prišlo do napake!",

            accessionModal: {
                title: "Izročitev",
                confirmForAccession: "Potrdi za izročitev",
                rejectForAccession: "Zavrni za izročitev",
            },

            documentListPretecenRokHrambe: {

                title: "Gradivo s pretečenim rokom hrambe",
            },

            documentListReview: {

                title: "Gradivo za izločitev",

                reAssignToDocumentationAdmin: "Predodeli skrbniku dokumentacije",

                reAssignModal: {

                    title: "Predodeli izbrano gradivo skrbniku dokumentacije",
                    reAssign: "Predodeli",

                },

                extendExpirationModal: {

                    title: "Podaljšaj rok hrambe izbranega gradiva",
                    newExpiration: "Nov rok hrambe",
                    extendExpiration: "Podaljšaj rok hrambe",

                },

                sendDocumentsForDestructionModal: {
                    title: "Pošlji gradivo v uničenje",
                    selectForDestruction: "Označi za uničenje",
                },


                expirationValueNeedsToBeSelectedSwal: "Za podaljšanje roka hrambe je potrebno izbrati vrednost roka hrambe!",

            },

            documentListReviewSkrbnik: {
                title: "Gradivo, dodeljeno v pregled",

            },

            documentList2: {

                title: "Gradivo, potrjeno za uničenje",

                destroyDocumentsModal: {
                    title: "Uničenje izbranega gradiva",
                    confirmDocumentDestroyPrompt: "Če želite uničiti izbrano gradivo, potrdite izbiro.",
                    destroySelectedDocuments: "Uniči izbrano gradivo",



                    selectedDocumentsContainAttachmentsOrComponentsSwal: {

                        title: "Izbrano gradivo ima priloge oz. komponente!",
                        destroyAnyway: "Vseeno uniči izbrano gradivo",
                        cancelDestruction: "Prekliči uničenje",

                        attachmentsOrComponents: "Priloge oz. komponente",

                    },

                    errorGettingInformationOnAttachmentsAndComponentsToast: "Pri pridobivanju informacij o prilogah in komponentah izbranega gradiva je prišlo do napake!",

                },
            },

            documentList3: {
                title: "Gradivo, primerno za izročitev državnemu arhivu",

            },

            documentList4: {
                title: "Gradivo, predlagano za uničenje",

                prolongModal: {
                    title: "Podaljšaj rok hrambe izbranega gradiva",
                },

                sendDocumentsForDestructionModal: {
                    title: "Pošlji gradivo v uničenje",
                    confirmForDestruction: "Potrdi za uničenje",
                },

            },

            documentList5: {
                title: "Gradivo, izbrano za izročitev državnemu arhivu",
                documentsConfirmedForArchive: "Gradivo, izbrano za izročitev državnemu arhivu",
                lastStatusChangeDate: "Datum zadnje spremembe statusa",

            },

            documentListLongTermStorage: {
                title: "Pretvorba v format za dolgoročno hrambo",

            },

            izrocenoGradivo: {
                title: "Izročeno gradivo",
                advancedSearch: "Napredno iskanje",

            },

            kandidatiZaIzrocanje: {
                title: "Gradivo, potrjeno za izročitev državnemu arhivu",
                showDocumentsInLongTermStorageFormat: "Prikaži samo gradivo v formatu za dolgoročno hrambo",

                performAccessionModal: {
                    title: "Izroči izbrano gradivo",

                },


                documentAccessionErrorToast: "Pri izročanju gradiva je prišlo do napake!",
                resultsNotSuitableForAccession: "Gradiva poiskanega na podlagi izbranih iskalnih pogojev ni mogoče izročiti. Poskusite iskati z drugačnimi iskalnimi pogoji."

            },

        },

        //documentEvipTestClient: {},

        documentLongTermStorageDetails: {

            documentForLongTermStorageManualAdd: "Ročno dodajanje gradiva v obliki za dolgoročno hrambo",

            cannotGetLongTermStorageConversionInfo: "Podatkov o pretvorbi za dolgoročno hrambo ni mogoče pridobiti",


        },

        registry: {
            registerOptions: [
                {id: "document-source", name: "IZVOR GRADIVA"},
                {id: "storage-place", name: "MESTO HRAMBE"},
                {id: "confidentiality", name: "STOPNJA ZAUPNOSTI"},
                {id: "register-users", name: "UPORABNIKI VPISNIKOV"},
                {id: "document-type", name: "VRSTA DOKUMENTA"}
            ],
        },

        packageExport: {
            title: "Priprava paketa gradiva za uvoz v drug sistem",
            classes: "Klasifikacijski razredi",
            generatePackage: "Izdelaj paket",
            okMessage: "Kreiranje paketa uspešno zagnano. Napredek lahko spremljate v sistemskem logu.",
            errorMessage: "Pri kreiranju paketa gradiva je pršlo do napake.",
            countErrorMessage: "Pri štetju enot gradiva je pršlo do napake.",
            packageCountInfoTitlePartOne: "Paket bo vseboval",
            packageCountInfoTitlePartTwo: "enot gradiva.",
            confirmCountInfoButtonLabel: "Nadaljuj s pripravo paketa"
        },

        documentMetadataPrint: {

            pageLeaveWarning: "Leaving this page will block the parent window!\nPlease select \"Stay on this Page option\" and use the\nCancel button instead to close the Print Preview Window.\n",
        },

        documentSearch: {
            title: "Iskanje dokumentov",

            documentSearchFullText: {
                title: "Iskanje po besedilu",
                info1: "Z iskanjem po besedilu lahko poiščete zadetke neodvisno od tega, v katerem polju se izraz nahaja.",
                info2: "S tem načinom iskanja lahko preverite, v kakšni meri je vaše iskanje dalo rezultate.",

                putSearchQueryInQuotesInfo: "Za iskanje s točnim ujemanjem iskalni pojem vstavite v narekovaje.",

            },
            documentSearchDetailed: {
                title: "Osnovno iskanje po metapodatkih gradiva",
                info1: "Z iskanjem po metapodatkih najdete iskani izraz ali besedno zvezo v izbranih metapodatkih gradiva.",
                info2: "Uporabite iskanje po metapodatkih, če želite poiskati točno določeno gradivo in poznate pomen in uporabo posameznih metapodatkov.",
                operator: "Operator",
                operatorOptions: [
                    {
                        id: 'AND',
                        description: 'IN',
                    },
                    {
                        id: 'OR',
                        description: 'ALI',
                    },
                    {
                        id: 'NOT',
                        description: 'NE',
                    }
                ],

                 searchableFields: [
                    {
                        id: 'EH:ID_gradiva',
                        description: 'Zunanji ID gradiva',
                    },
                    {
                        id: 'EH:fizicno_gradivo',
                        description: 'Gradivo v fizični obliki',
                    },
                    {
                        id: 'id',
                        description: 'UUID',
                    },
                    {
                        id: 'EH:status_gradiva',
                        description: 'Status gradiva',
                    },
                    {
                        id: 'EH:stopnja_zaupnosti',
                        description: 'Stopnja zaupnosti',
                    },
                    {
                        id: 'EH:datum_gradiva',
                        description: 'Datum zajema gradiva',
                    },
                    {
                        id: 'EH:mesto_hrambe',
                        description: 'Mesto hrambe',
                    },
                    {
                        id: 'cm:title',
                        description: 'Naslov',
                    },
                    {
                        id: 'EH:klasifikacijska_oznaka_razreda',
                        description: 'Klasifikacijska oznaka razreda',
                    },
                    {
                        id: 'EH:opravilna_stevilka_zadeve',
                        description: 'Opravilna številka zadeve',
                    },
                    {
                        id: 'EH:ID_zadeve',
                        description: 'ID zadeve',
                    },
                    {
                        id: 'EH:oznaka_vpisnika',
                        description: 'Oznaka vpisnika',
                    },
                    {
                        id: 'EH:oznaka_povezanega_sistema',
                        description: 'Oznaka povezanega sistema',
                    },
                    {
                        id: 'EH:sodisce',
                        description: 'Sodišče',
                    },
                    {
                        id: 'cm:description',
                        description: 'Kratek opis vsebine',
                    },
                    {
                        id: 'EH:kljucne_besede',
                        description: 'Ključne besede',
                    },
                    {
                        id: 'EH:gradivo_e_podpisano',
                        description: 'Gradivo e-podpisano'
                    },
                    {
                        id: 'EH:tip_gradiva',
                        description: 'Tip gradiva'
                    },
                     {id: 'EH:izroceno_dne', description: 'Datum kreiranja paketa za izročanje'},
                     {id: 'EH:datum_izteka_roka_hrambe', description: 'Datum izteka roka hrambe'},
                     {id: 'EH:datum_pregleda_izrocanje', description: 'Datum pregleda izročanja'},
                     {id: 'EH:datum_pregleda', description: 'Datum pregleda gradiva'},
                     {id: 'EH:format_datum_preverbe', description: 'Datum preverbe'},
                     {id: 'EH:datum_unicenja', description: 'Datum uničenja'},
                     {id: 'EH:datum_zacetka_teka_roka_hrambe', description: 'Datum začetka teka roka hrambe'},
                     {id: 'EH:izroceno', description: 'Izročitev izvedena'},
                     {id: 'EH:prevzeto', description: 'Prevzeto'},
                     {id: 'EH:id_paketa', description: 'ID paketa'},
                     {id: 'EH:izbris_originala', description: 'Izbris originala'},
                     {id: 'EH:izvajalec_pregleda', description: 'Izvajalec pregleda'},
                     {id: 'EH:izvor_gradiva', description: 'Izvor dokumenta'},
                     {id: 'EH:izvorna_oblika', description: 'Izvorna oblika gradiva'},
                     {id: 'EH:komentar_pregleda', description: 'Komentar pregleda'},
                     {id: 'EH:izrocanje_komentar', description: 'Komentar pri izročitvi'},
                     {id: 'EH:koncni_format', description: 'Končni format'},
                     {id: 'EH:lokacija_hrambe', description: 'Lokacija hrambe'},
                     {id: 'EH:naslovnik', description: 'Naslovnik'},
                     {id: 'EH:oblika_gradiva_po_PETZ', description: 'Oblika gradiva po P-ETZ'},
                     {id: 'EH:obrazlozitev_izrednega_izbrisa', description: 'Obrazložitev izrednega izbrisa'},
                     {id: 'EH:odlocitev_pregleda', description: 'Odločitev pregleda'},
                     {id: 'EH:ciljni_povezan_sistem', description: 'Ciljni povezan sistem'},
                     {id: 'EH:oznaka_priloge_v_popisu_spisa', description: 'Oznaka priloge v popisu spisa'},
                     {id: 'EH:posiljatelj_vloznik', description: 'Pošiljatelj - Vložnik'},
                     {id: 'EH:pregledan_za_izrocanje', description: 'Pregledan za izročanje'},
                     {id: 'EH:izvorna_oblika_razlicica', description: 'Različica izvorne oblika gradiva'},
                     {id: 'EH:razlog_unicenja', description: 'Razlog uničenja gradiva'},
                     {id: 'EH:trajanje_roka_hrambe', description: 'Trajanje omejenega roka hrambe'},
                     {id: 'EH:rok_hrambe', description: 'Rok hrambe'},
                     {id: 'EH:status_pregleda', description: 'Status pregleda'},
                     {id: 'EH:izrocil', description: 'Izročil'},
                     {id: 'EH:izvajalec_unicenja', description: 'Izvajalec uničenja'},
                     {id: 'EH:ustreznost_formata', description: 'Ustreznost formata za Arhiv RS'},
                     {id: 'EH:povezave_na_vodilne_dokumente', description: 'Povezave na vodilne dokumente'},
                     {id: 'EH:vrsta_gradiva', description: 'Vrsta gradiva'},
                     {id: 'rma:ghosted', description: 'Gradivo izbrisano'},
                     {id: 'EH:datum_zadnje_spremembe_statusa_gradiva', description: 'Datum zadnje spremembe statusa'},
                     {id: 'EH:izrocitev', description: 'Gradivo, izbrano za izročitev državnemu arhivu'},
                     {id: 'EH:prikazi_gradivo_v_formatu_za_dolgorocno_hrambo', description: 'Prikaži samo gradivo v formatu za dolgoročno hrambo'},
                     {id: 'EH:prikaziNepretecenRokHrambe', description: 'Prikaži tudi gradivo, ki mu še ni pretekel rok hrambe'},


                ],


            },
            documentSearchTectonical: {
                title: "Iskanje po vsebini klasifikacijskega načrta",
                info1: "Iskanje po vsebini arhiva vam omogoča pregledovanje gradiva po hierarhiji klasifikacijskega načrta, od nadrejene enote do posameznega dokumenta. Na podlagi položaja v klasifikacijskem načrtu boste dobili veliko informacij o posameznem dokumentu.",
                info2: "Če želite pregledovati gradivo po klasifikacijskem načrtu, uporabite iskanje po vsebini klasifikacijskega načrta.",
                showCaseFiles: "Prikaži zadeve",
                loadMoreDocuments: "Naloži več dokumentov",
                selectedDirectoryIsEmptyError: "Izbrani razred ne vsebuje gradiva!",
                case: "Zadeva:",

                noPermissionToViewClassificationPlanSwal: "Nimate ustreznih pravic za pregled klasifikacijskega načrta!",
            },
            documentSearchQuery: {
                title: " Napredno iskanje po metapodatkih gradiva",
                info1: "Z naprednim iskanjem po metapodatkih lahko iščete gradivo po kateremkoli metapodatku gradiva tako, da z uporabo standardnih operatorjev sami sestavite iskalno poizvedbo.",
                info2: "Uporabite napredno iskanje po metapodatkih, če želite poiskati točno določeno gradivo, poznate pomen in uporabo posameznih metapodatkov ter želite v iskanju uporabiti dodatne metapodatke, ki niso zajeti v osnovnem iskanju po metapodatkih.",
                field: "Polje:",
                chooseField: "Izberite polje:",
            },

            openingEnabledJustForFilesErrorToast: 'Odpiranje je omogočeno samo za datoteke.',



            facetQueries: [
                {"query": "content.size:[0 TO 102400]", "label": "0MB - 0.1MB"},
                {"query": "content.size:[102400 TO 1048576]", "label": "0.1MB do 1MB"},
                {"query": "content.size:[1048576 TO 10485760]", "label": "1MB do 10MB"},
                {"query": "content.size:[10485760 TO 10485760000000]", "label": "nad 10MB"}
            ],
            facetFields: {
                "facets": [
                    {"field": "content.mimetype", "label": "mimetype"},
                    {"field": "EH:status_gradiva", "label": "statusGradiva"},
                    {"field": "EH:klasifikacijska_oznaka_razreda", "label": "klasifikacijskaOznakaRazreda"},
                    {"field": "EH:sodisce", "label": "sodišče"},
                    {"field": "EH:opravilna_stevilka_zadeve", "label": "opravilnaŠtevikaZadeve"},
                    {"field": "EH:fizicno_gradivo", "label": "fizičnoGradivo"},
                    {"field": "EH:oznaka_povezanega_sistema", "label": "oznakaPovezanegaSistema"},
                    {"field": "EH:oznaka_vpisnika", "label": "oznakaVpisnika"},
                    {"field": "EH:rok_hrambe", "label": "rokHrambe"},
                ]
            }
        },

        //documentTestClient: {},

        models: {

            models: " Modeli",
            createModel: "Ustvari model",

            activate: "Activate",
            deactivate: "Deactivate",

            active: "Active",
            inactive: "Inactive",

            modelDeleteModal: {

                title: "Delete model",
                prompt: "Do you really want to delete this model?",
            },

            modelCreateModal: {
                title: "Create model:",
            },

            modelEditModal: {
                title: "Edit model:",
            },

            namespace: "Namespace",
            name: "Name",
            actions: "Actions",


        },

        properties: {

            metadata: "Metapodatki",
            createMetadata: "Ustvari metapodatek",

            propertyCreateModal: {
                title: "Create property:",
            },

            propertyEditModal: {
                title: "Edit property:",
            },

            propertyDeleteModal: {
                title: "Delete property",
                prompt: "Do you really want to delete this property?",

            },

            models: "Modeli",
            aspects: "Aspekti",

            namespace: "Namespace",
            name: "Name",
            dataType: "Data type",
            requirement: "Requirement",
            action: "Action",

            mandatory: "Mandatory",
            optional:  "Optional",
            false: "False",
            yes: "Yes",
            no: "No",
        },

        reports: {
            reports: "Poročila",
            myReports: "Moja poročila",
            createNewReport: "Ustvari novo pročilo",

            query: "Poizvedba",

            errorBold: "NAPAKA",

            noDescription: "ni opisa",
            unknownReportType: "Neznan tip poročila",

            deleteReportSwal: {
                prompt: "Ali ste prepričani, da želite izbrisati poročilo",
            }

        },

        rocniVnosStatusaPrevzemaPaketa: {

            title: "Ročni vnos statusa prevzema paketa",

            fileNumber: "Št. datotek",
            createdBy: "Ustvaril",

            noDescription: "ni opisa",
            packageWasAccepted: "Paket je že bil potrjen!",


            confirmPackageSwal: {
                prompt: "Ali ste prepričani, da želite potrditi paket z opisom",
                confirmPackage: "Potrdi paket",
            },

            packageConfirmedSuccessToast: "Paket uspešno potrjen!",
            packageConfirmedErrorToast: "Pri potrjevanju paketa je prišlo do napake!",

            rejectPackageSwal: {
                prompt: "Ali ste prepričani, da želite zavrniti paket z opisom",
                rejectPackage: "Zavrni paket",
            },

            packageRejectedSuccessToast: "Paket uspešno zavrnjen!",
            packageRejectedErrorToast: "Pri zavrnitvi paketa je prišlo do napake!",

            packageDownloadErrorToast: "Pri prenosu paketa je prišlo do napake!",

        },

        status: {

            cacheInstances: "Instance predpomnilnika",
            cacheTestClient: "Testni klient za predpomnilnike",

            mapViewTab: "Prikaz na zemljevidu",
            tableViewTab: "Tabelarični prikaz",

            writeSearchPhrase: "vnesi iskalni pojem",

            noInfo: "ni podatka",

            addCacheInstance: "Dodaj instanco predpomnilnika",

            name: "Naziv",
            uuid: "UIID oznaka",
            state: "Stanje",
            activity: "Aktivnost",


            error: "napaka",
            problem: "težava",


            cacheDeletionSwal: {
                prompt: "Ali ste prepričani, da želite izbrisati predpomnilnik",
            },


        },

        unclassifiedFilesReview: {

            title: "Pregled neklasificiranega gradiva",
            folderDoesNotContainSubfoldersOrFiles: "Mapa nima podmap in datotek",
            loadMoreDocuments: "Naloži več dokumentov",
        },

        uploadDocumentInLongTermStorageFormat: {

            title: "Ročno dodajanje gradiva v obliki za dolgoročno hrambo",
            fileForDownload: "Datoteka za prenos",
            fileDownload: "Prenos datoteke",
            customErrorMessage: "Pri prenosu datoteke na strežnik je prišlo do napake. Preverite ali je naložena datoteka v pravilni obliki za dolgoročno hrambo.",

            fileForDownloadNotSelectedToast: "Datoteka za prenos ni izbrana",

            fileUploadSuccessToast: "Gradivo uspešno naloženo!",
            fileUploadErrorToast: "Napaka pri nalaganju na strežnik",

        },

        metadata: {

            name: "Ime",
            originalName: "Originalno ime",
            title: "Naslov",
            id: "UUID",
            description: "Kratek opis vsebine",
            author: "Avtor",
            mimeTypeName: "Vrsta",
            mimetype: "Vrsta dokumenta",
            sizeInBytes: "Velikost",
            fileSize: "Velikost datoteke",
            createdByUserDisplayName: "Ustvaril",
            createdAt: "Ustvarjeno",
            createdAtTimestamp: "Datum in ura zajema enote gradiva",
            modifiedByUserDisplayName: "Spremenil",
            modifiedAt: "Spremenjeno",
            certNum: "Številka certifikata",

            attachments: "Priloge",
            components: "Komponente",
            signature: "Podpis",

        },

        classificationPlanMetadata: {

            expiration: "Rok hrambe",
            expirationYears: "Omejeno na",
            expirationType: "Vrsta gradiva",

            registry: "Vpisnik",
            registries: "Vpisniki",

            connectedSystems: "Povezani sistemi",
            connectedSystem: "Povezan sistem",

            classificationLabel: "Oznaka razreda",
            classificationLabelName: "Naziv razreda",

            usageEndDate: "Konec uporabe",
            usageStartDate: "Začetek uporabe",
            creationDate: "Čas nastanka",

        },

        validationMessages: {
            required: 'je obvezno',
            notValid: 'ni veljavno',
            field: 'polje',
        },

        globals: {
            noOptions: "Ni zadetkov ali pa do njih nimate dostopa.",
            noData: 'Ni podatkov.',
            back: "Nazaj",
            cancel: "Prekliči",
            close: "Zapri",
            error: "Napaka",
            accept: "Potrdi",
            continue: "Nadaljuj",
            save: "Shrani",
            delete: "Izbriši",
            edit: "Uredi",
            datePickerLocale: "sl",
            search: "Išči",
            archive: "arhiv",
            yes: "DA",
            no: "NE",
            ok: "OK",
            download: "Prenesi",
            print: "Tiskaj",
            enterValue: "vnesi vrednost",
            selectDate: "izberite datum",
            upload: "Naloži",
            searchQuery: "Iskalni niz",
            description: "Opis",
            warningTitle: "Opozorilo",
            documentPreviewNotAvailable: "Predogled gradiva ni na voljo!",
            court: "Sodišče",
            actions: "Akcije",
            adminTools: "Admin orodja",
            documentInformation: "Podatki o dokumentu",
            documentMetadata: "Metapodatki dokumenta",
            documentPreview: "Predogled dokumenta",
            saveChanges: "Shrani spremembe",
            discardChanges: "Opusti spremembe",
            status: "Status",
            caseNumber: "Opravilna številka zadeve",
            prikaziNepretecenRokHrambe: "Prikaži tudi gradivo, ki mu še ni pretekel rok hrambe",
            classificationPlanNotDefined: " Klasifikacijski načrt ni opredeljen.",
            comment: "Komentar",
            commentMissing: "Komentar je obvezen in mora biti dolg vsaj 8 znakov.",
            date: "Datum",
            rootFolder: "Korenska mapa",
            selectedClass: "Izbrani razred",
            clearAllFilters: "Izbriši vse filtre",
            lastChange: "Zadnja sprememba",
            now: "Zdaj",

            export: "Izvoz",
            move: "Premesti",

            getClassificationPlan: "Pridobi KN",

            minorMajorOptions: ['MINOR', 'MAJOR'],

            confirm: "Potrdi",
            reject: "Zavrni",

            and: "IN",
            or: "ALI",
            not: "NE",

            customDatePickerShortcuts: [
                {key: 'thisWeek', label: 'Ta teden', value: 'isoWeek'},
                {key: 'lastWeek', label: 'Prejšnji teden', value: '-isoWeek'},
                {key: 'last7Days', label: 'Zadnjih 7 dni', value: 7},
                {key: 'last30Days', label: 'Zadnjih 30 dni', value: 30},
                {key: 'thisMonth', label: 'Ta mesec', value: 'month'},
                {key: 'lastMonth', label: 'Prejšnji mesec', value: '-month'},
                {key: 'thisYear', label: 'Letošnje leto', value: 'year'},
                {key: 'lastYear', label: 'Prejšnje leto', value: '-year'}
            ],
            datePick: {
                nextMonthCaption: 'Naprej',
                prevMonthCaption: 'Nazaj',
                setTimeCaption: 'Določi čas:',
                weekdays: [
                        'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob', 'Ned'
                    ]
                ,
                months: [
                        'januar', 'februar', 'marec', 'april',
                        'maj', 'junij', 'julij', 'avgust',
                        'september', 'oktober', 'november', 'december'
                ]

            }
        },

        premikanjeRazredov: {
            premestitevRazredovZgradivom: "Premestitev razredov z gradivom",
            deleteConfirmation: "Ali ste prepričani, da želite izbrisati dogodek z id oznako",
            classesToMoveList: "Seznam razredov določenih za premik",
            noClassesChosenToMove: "Trenutno ni izbranih razredov za premik.",
            classToMove: "Razred za premik",
            newParentClass: "Nov nadrejeni razred",
            classificationLabel: "Oznaka razreda",
            expirationDateData: "Podatki o rokih hrambe",
            actions: "akcije",
            noChangesToExpirationDate: "Ni sprememb v rokih hrambe.",
            edit: "Uredi",
            remove: "Odstrani",
            checkMoveDetails: "Preveri podrobnosti o premikih (št. razredov za premik:",
            changeExpirationDate: "Spremeni roke hrambe",
            addingMoveToList: "Dodajanje premika na seznam razredov določenih za premik",
            editMoveOnList: "Urejanje premika iz seznama razredov določenih za premik",
            chooseClassToMove: "Izberite razred, ki ga želite premakniti",
            chooseNewParentClass: "Izberanemu razredu določite nov nadrejeni razred",
            enterNewLabelName: "Vnesite novo klasifikacijsko oznako razreda:",
            moveReason: "Vnesite razlog za premeščanje ali spremembo:",
            reason: "Razlog za premeščanje ali spremembo",
            expirationDateChange: "Spremeni roke hrambe",
            addMoveToList: "Dodaj na seznam razredov določenih za premik",
            updateValues: "Posodobi vrednosti",
            cancelEditing: "Prekliči urejanje",
            movingClassDetails: "Podrobnosti o premiku razreda",
            numberOfNameChanges: "Št. sprememb nazivov:",
            numberOfExpirationDateChanges: "Št. sprememb rokov hrambe:",
            labelBefore: "Oznaka - prej:",
            labelAfter: "Oznaka - potem:",
            expirationDateBefore: "Roki hrambe - prej:",
            expirationDateAfter: "Roki hrambe - potem:",
            moveTimeEstimate: "Ocena trajanja izvedbe premika",
            durations: "Trajanje:",
            setTimeBeforeMove: "Nastavitev časa začetka izvajanja premika",
            confirmForMove: "Potrdi zahtevek za premestitev",
            eventDetails: "Podrobnosti dogodka",
            changed: "Spremenjeno:",
            start: "Začetek izvajanja:",
            changes: "Spremembe",
            author: "Avtor",
            created: "Ustvarjeno",
            status: "Status:",
            reasonIsRequired: "Polje \"Razlog za premik\" ne sme biti prazno!",
            reasonIsRequiredAlt: "Vnos komentarja je obvezen za nadaljevanje.",
            errorClassAlreadyScheduledToBeEdited: "Eden ali več izbranih razredov, ki jih želite označiti za premestitev, je že v čakanju na premestitev. Novega zahtevka za premestitev zato ni mogoče oddati.",
            errorNewClassNameNotValid: "Nova oznaka enega ali več razredov, ki ste jih označili za premestitev ni ustrezna.",
            errorClassDuplicated: "Vsaj en razred, ki ste označili za premestitev, je podvojen, zato premestitev ni mogoča."
        },

        interceptors: {

            accessDeniedSwal: {
                prompt: "Dostop ni dovoljen.",
                confirmButtonText: "Na stran za prijavo",

            },

            dataNotSavedDueToValidationErrorToast: "Zaradi napak pri validaciji podatki niso bili sharanjeni!",

            serverCommunicationErrorSwal: "Pri komunikaciji s strežnikom je prišlo do napake.",

            thisServerCommunicationErrorSwal: "Pri komunikaciji s strežnikom je prišlo do te napake: \n",

            documentAccessDeniedSwal: {
                title: "Dostop ni mogoč",
                prompt: "Dokument ne obstaja ali pa nimate ustreznih pravic za dostop.",
            },

            fileTooBigUploadErrorSwal: {
                prompt: "Datoteka, ki jo poskušate naložiti, je prevelika.",
            },

            timeoutErrorMessage: "Čas za odziv strežnika je potekel, zahteva še traja. Prosimo, preverite kasneje oz. ponovite akcijo.",

            unknownServerErrorSwal: "Na strežniku je prišlo do neznane napake.",

            unknownServerCommunicationErrorSwal: "Pri komunikaciji s strežnikom je prišlo do neznane napake.",

        },

        globalFunctions: {


            generateReportSwal: {
                title: "Opis poročila",
                enterReportDescription: "Vnesi opis poročila",
                confirmButtonText: "Oddaj zahtevek za poročilo",

            },

            reportGenerationSuccessSwal: {
                title: "Poročilo uspešno ustvarjeno!",
                prompt: "Dosegljivo je v razdelku Poročila, direktno pa ga lahko prenesete s klikom na gumb \"Prenos poročila\".",
                reportDownload: "Prenos poročila",
            },

            highQuantityOfSelectedDataDetectedSwal: {

                title: "Zaznana velika količina izbranih podatkov!",
                prompt: "Poročila za večjo količino izbranih podatkov trajajo dlje časa. Ste prepričani, da želite oddati zahtevek za izvedbo poročila za izbrane podatke?",
                confirmButtonText: "Oddaj zahtevek za izdelavo poročila",

            },

            reportCreationWillTakeALongTimeSwal: {

                title: "Kreiranje poročila bo trajalo dlje časa!",
                prompt: "Prosimo, da v navigacijskem meniju izberete možnost \"Poročila\" in preverite, če je želeno poročilo že na voljo.",
                promptFS: "Poročilo bo kreirano na alfresco strežniku na lokaciji:",
            },

            reportGenerationErrorSwal: {

                title: "Pri kreiranju poročila je prišlo do napake!",
                prompt: "Več informacij je dosegljivih ob kliku na gumb \"Prenos podorobnosti o napaki\".",
                confirmButtonText: "Prenos podorobnosti o napaki",

            },

            noResultsToShowInReport: {

                title: "Ni rezultatov za prikaz v poročilu!",
                prompt: "Ker za izbrane parametre ni bilo rezultatov, je bila izdelava poročila preklicana. Poskusite ustvariti poročilo z drugačnimi parametri.",

            },

            oiiuColumns:  [
                {
                    label: 'Naslov',
                    field: 'cm:title',
                    sort: {}
                },
                {
                    label: 'UUID',
                    field: 'id',
                    sort: false
                },
                {
                    label: 'Opis',
                    field: 'cm:description',
                    sort: {}
                },
                {
                    label: 'Rok hrambe',
                    field: 'EH:rok_hrambe',
                    sort: true
                },
                // {
                //     label: 'Trajanje roka hrambe',
                //     field: 'EH:trajanje_roka_hrambe',
                //     sort: {}
                // },
                {
                    label: 'Razred',
                    field: 'EH:klasifikacijska_oznaka_razreda',
                    sort: {}
                },
                {
                    label: 'Zunanji ID gradiva',
                    field: 'EH:ID_gradiva',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Datum začetka roka hrambe',
                    field: 'EH:datum_zacetka_teka_roka_hrambe',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Datum izteka roka hrambe',
                    field: 'EH:datum_izteka_roka_hrambe',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Ustvarjeno',
                    field: 'createdAt',
                    style: {
                        width: '200px',
                    },
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Spremenjeno',
                    field: 'modifiedAt',
                    style: {
                        width: '200px',
                    },
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Datum gradiva',
                    field: 'EH:datum_gradiva',
                    style: {
                        width: '200px',
                    },
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Status gradiva',
                    field: 'EH:status_gradiva',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Opr. št. zadeve',
                    field: 'EH:opravilna_stevilka_zadeve',
                    sort: {}
                },
                {
                    label: 'Sodišče',
                    field: 'EH:sodisce',
                    sort: {}
                },
                {
                    label: 'Povezan sistem',
                    field: 'EH:oznaka_povezanega_sistema',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Pretvorba za dolg. hrambo',
                    field: 'EH:ustreznost_formata',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Mesto hrambe',
                    field: 'EH:mesto_hrambe',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Stopnja zaupnosti',
                    field: 'EH:stopnja_zaupnosti',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Velikost',
                    field: 'content.size',
                    hidden: true,
                    sort: {}
                }

            ],

            izrocenoGradivoColumns:  [
                {
                    label: 'Naslov',
                    field: 'cm:title',
                    sort: {}
                },
                {
                    label: 'UUID',
                    field: 'id',
                    sort: false
                },
                {
                    label: 'Opis',
                    field: 'cm:description',
                    sort: {}
                },
                {
                    label: 'Rok hrambe',
                    field: 'EH:rok_hrambe',
                    sort: true
                },
                // {
                //     label: 'Trajanje roka hrambe',
                //     field: 'EH:trajanje_roka_hrambe',
                //     sort: {}
                // },
                {
                    label: 'Razred',
                    field: 'EH:klasifikacijska_oznaka_razreda',
                    sort: {}
                },
                {
                    label: 'Zunanji ID gradiva',
                    field: 'EH:ID_gradiva',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Datum začetka roka hrambe',
                    field: 'EH:datum_zacetka_teka_roka_hrambe',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Datum izteka roka hrambe',
                    field: 'EH:datum_izteka_roka_hrambe',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Ustvarjeno',
                    field: 'createdAt',
                    style: {
                        width: '200px',
                    },
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Spremenjeno',
                    field: 'modifiedAt',
                    style: {
                        width: '200px',
                    },
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Datum gradiva',
                    field: 'EH:datum_gradiva',
                    style: {
                        width: '200px',
                    },
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Status gradiva',
                    field: 'EH:status_gradiva',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Opr. št. zadeve',
                    field: 'EH:opravilna_stevilka_zadeve',
                    sort: {}
                },
                {
                    label: 'Sodišče',
                    field: 'EH:sodisce',
                    sort: {}
                },
                {
                    label: 'Povezan sistem',
                    field: 'EH:oznaka_povezanega_sistema',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Pretvorba za dolg. hrambo',
                    field: 'EH:ustreznost_formata',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Mesto hrambe',
                    field: 'EH:mesto_hrambe',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Stopnja zaupnosti',
                    field: 'EH:stopnja_zaupnosti',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Velikost',
                    field: 'content.size',
                    hidden: false,
                    sort: {}
                },
                {
                    label: 'Izvorna oblika zapisa',
                    field: 'content.mimetype',
                    hidden: false,
                    sort: {}
                },
                {
                    label: 'Tip gradiva',
                    field: 'EH:tip_gradiva',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Izročeno',
                    field: 'EH:izroceno',
                    hidden: false,
                    sort: {}
                },
                {
                    label: 'Izročeno dne',
                    field: 'EH:izroceno_dne',
                    hidden: false,
                    sort: {}
                },
                {
                    label: 'Izročil',
                    field: 'EH:izrocil',
                    hidden: false,
                    sort: {}
                },
                {
                    label: 'Prevzeto',
                    field: 'EH:prevzeto',
                    hidden: false,
                    sort: {}
                },
                {
                    label: 'ID paketa',
                    field: 'EH:id_paketa',
                    hidden: false,
                    sort: {}
                }
            ],

            searchResultsColumns: [
                {
                    label: 'Naslov',
                    field: 'cm:title',
                    sort: {}
                },
                {
                    label: 'UUID',
                    field: 'id',
                    sort: false
                },
                {
                    label: 'Opis',
                    field: 'cm:description',
                    sort: {}
                },
                {
                    label: 'Rok hrambe',
                    field: 'EH:rok_hrambe',
                    sort: true
                },
                // {
                //     label: 'Trajanje roka hrambe',
                //     field: 'EH:trajanje_roka_hrambe',
                //     sort: {}
                // },
                {
                    label: 'Razred',
                    field: 'EH:klasifikacijska_oznaka_razreda',
                    sort: {}
                },
                {
                    label: 'Zunanji ID gradiva',
                    field: 'EH:ID_gradiva',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Datum začetka roka hrambe',
                    field: 'EH:datum_zacetka_teka_roka_hrambe',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Datum izteka roka hrambe',
                    field: 'EH:datum_izteka_roka_hrambe',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Ustvarjeno',
                    field: 'createdAt',
                    style: {
                        width: '200px',
                    },
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Spremenjeno',
                    field: 'modifiedAt',
                    style: {
                        width: '200px',
                    },
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Datum gradiva',
                    field: 'EH:datum_gradiva',
                    style: {
                        width: '200px',
                    },
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Status gradiva',
                    field: 'EH:status_gradiva',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Opr. št. zadeve',
                    field: 'EH:opravilna_stevilka_zadeve',
                    sort: {}
                },
                {
                    label: 'Sodišče',
                    field: 'EH:sodisce',
                    sort: {}
                },
                {
                    label: 'Povezan sistem',
                    field: 'EH:oznaka_povezanega_sistema',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Pretvorba za dolg. hrambo',
                    field: 'EH:ustreznost_formata',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Mesto hrambe',
                    field: 'EH:mesto_hrambe',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Stopnja zaupnosti',
                    field: 'EH:stopnja_zaupnosti',
                    hidden: true,
                    sort: {}
                },
                {
                    label: 'Velikost',
                    field: 'content.size',
                    hidden: false,
                    sort: {}
                },
                {
                    label: 'Izvorna oblika zapisa',
                    field: 'content.mimetype',
                    hidden: false,
                    sort: {}
                },
                {
                    label: 'Tip gradiva',
                    field: 'EH:tip_gradiva',
                    hidden: true,
                    sort: {}
                }


            ],

        },

        router: {
            accessDeniedSwal: "Dostop ni dovoljen."
        },
    }
}



// WEBPACK FOOTER //
// ./src/translations/sl.js